import StateManager from './StateManager';
import $ from 'jquery';
import _ from 'underscore';

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    $(node).find('.js-scuba__list').each(function(i, list) {
        new Scuba_ListLazyLoading(list);
    });
});

/* --------------------------------------------------

    UTILS

-------------------------------------------------- */

function parseStateFromSource(source) {

    var lists = [];

    // même expression régulière avec le flag "global" pour la 1re passe et sans pour la 2e
    var rgx1 = /<!--\[scuba-list-items\((\d+)\)-->[\s\n\r]*([\w\W]*?)[\s\n\r]*<!--scuba-list-items\]-->/gi;
    var rgx2 = /<!--\[scuba-list-items\((\d+)\)-->[\s\n\r]*([\w\W]*?)[\s\n\r]*<!--scuba-list-items\]-->/i;

    // 1re passe pour extraire les groupes
    var matches = source.match(rgx1);

    if (matches) {
        var i = 0;
        var n = matches.length;
        var groupMatches;
        // boucle sur tous les groupes trouvés
        for (; i < n; i++) {
            source = matches[i];
            // seconde passe pour extraire le contenu de chaque groupe
            groupMatches = source.match(rgx2);
            if (groupMatches) {
                lists.push({
                    total : parseInt(groupMatches[1]),
                    source : groupMatches[2],
                });
            }
        }
    }

    return lists;
}





/* --------------------------------------------------

    (CLASS) LIST FORM

-------------------------------------------------- */

function Scuba_ListLazyLoading() {
    // console.log('new Scuba_ListLazyLoading()');
    this.initialize.apply(this, arguments);
}

$.extend(Scuba_ListLazyLoading.prototype, {

    initialize: function(list) {
        this.uid = _.uniqueId('scuba-');
        this.$list = $(list);
        this.$page = this.$list.closest('.js-scuba__page, .js-scuba__head');
        this.$page.on('scuba:dispose', $.proxy(this.dispose, this));

        // récupération des paramètres partagés
        this.params = this.$list.data('scuba-list-params');
        if (!this.params) {
            this.$list.data('scuba-list-params', this.params = {});
        }

        this.$itemsWrap = this.$list.find('.js-scuba__list__items');

        // écouteurs

        this.$list.on('itemsChanged', $.proxy(this.itemsChangedHandler, this));

        // init
        this.limit = 0;
        setTimeout($.proxy(this.itemsChangedHandler, this));
    },

    dispose: function() {
        // console.log('Scuba_ListLazyLoading.dispose()');
    },

    itemsChangedHandler: function() {
        var $more = this.$itemsWrap.find('.js-scuba__list__load-more');
        this.$moreLink && this.$moreLink.off();
        if ($more.length) {
            this.$more = $more;
            this.$moreLink = $more.find('a').on('click', $.proxy(this.listClickHandler, this));
        }
    },

    listClickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();
        // console.log('loadItems');
        this.loadItems(event.currentTarget.href);
    },

    loadItems: function(url) {
        // console.log('loadItems', url);

        var $more = this.$more;
        var $list = this.$list;
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
        })
        .done(function(data/*, textStatus, jqXHR*/) {
            var lists = parseStateFromSource(data.html);
            if (lists.length) {
                $more.replaceWith(lists[0].source);
            }
            // console.log(lists);
            $list.trigger('itemsChanged');
        })
        .fail(function(/*jqXHR, textStatus, errorThrown*/) {

        });
    },

});





/* --------------------------------------------------

    MODULE EXPORT

-------------------------------------------------- */

export default Scuba_ListLazyLoading;


// WEBPACK FOOTER //
// ./scripts/scuba/ListLazyLoading.js